webpackJsonp([114276838955818,60335399758886],{

/***/ 107:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(215);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(107);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "contact" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "section",
	                null,
	                _react2.default.createElement(
	                    "form",
	                    { method: "post", action: "https://formspree.io/geral@ahbusiness.com" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "field half first" },
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "name" },
	                            "Nome"
	                        ),
	                        _react2.default.createElement("input", { type: "text", name: "name", id: "name" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "field half" },
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "email" },
	                            "E-mail"
	                        ),
	                        _react2.default.createElement("input", { type: "text", name: "_replyto", id: "email" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "field" },
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "message" },
	                            "Mensagem"
	                        ),
	                        _react2.default.createElement("textarea", { name: "message", id: "message", rows: "6" })
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        { className: "actions" },
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("input", { type: "submit", value: "Enviar Mensagem", className: "special" })
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("input", { type: "reset", value: "Limpar" })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: "split" },
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "contact-method" },
	                        _react2.default.createElement("span", { className: "icon alt fa-envelope" }),
	                        _react2.default.createElement(
	                            "header",
	                            null,
	                            _react2.default.createElement(
	                                "h7",
	                                null,
	                                "E-mail"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "a",
	                            { href: "mail:to" },
	                            "geral@ahbusiness.com"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "contact-method" },
	                        _react2.default.createElement("span", { className: "icon alt fa-phone" }),
	                        _react2.default.createElement(
	                            "header",
	                            null,
	                            _react2.default.createElement(
	                                "h7",
	                                null,
	                                "Telefone"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            " (+351) 222 085 594"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "contact-method" },
	                        _react2.default.createElement("span", { className: "icon alt fa-home" }),
	                        _react2.default.createElement(
	                            "header",
	                            null,
	                            _react2.default.createElement(
	                                "h7",
	                                null,
	                                "Endere\xE7o"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "Rua Dom Jo\xE3o I, 256 Matosinhos, Portugal"
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Contact;
	module.exports = exports["default"];

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	    return _react2.default.createElement(
	        "footer",
	        { id: "footer" },
	        _react2.default.createElement(
	            "center",
	            null,
	            _react2.default.createElement(
	                "div",
	                { className: "inner" },
	                _react2.default.createElement(
	                    "ul",
	                    { className: "copyright" },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\xA9 AH BUSINESS"
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Designed by ",
	                        _react2.default.createElement(
	                            "a",
	                            { href: "https://mosano.eu" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "MOSANO"
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _AHbusinessLogotipo = __webpack_require__(524);
	
	var _AHbusinessLogotipo2 = _interopRequireDefault(_AHbusinessLogotipo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	    return _react2.default.createElement(
	        'header',
	        { id: 'header', className: 'alt' },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', className: 'logo__image' },
	            _react2.default.createElement('img', { src: _AHbusinessLogotipo2.default, alt: 'icon__logo' })
	        ),
	        _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	                'a',
	                { className: 'menu-lnk', onClick: props.onToggleMenu, href: 'javascript:;' },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Menu'
	                ),
	                _react2.default.createElement('div', { className: 'menu-button' })
	            )
	        )
	    );
	};
	
	Header.propTypes = {
	    onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(props) {
	    return _react2.default.createElement(
	        'nav',
	        { id: 'menu' },
	        _react2.default.createElement(
	            'div',
	            { className: 'inner' },
	            _react2.default.createElement(
	                'ul',
	                { className: 'links' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/' },
	                        'Home'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/group' },
	                        'Grupo AH Business'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/fields' },
	                        '\xC1reas de Neg\xF3cio'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/values' },
	                        'Nossos Valores'
	                    )
	                )
	            ),
	            _react2.default.createElement('ul', { className: 'actions vertical' })
	        ),
	        _react2.default.createElement(
	            'a',
	            { className: 'close', onClick: props.onToggleMenu, href: 'javascript:;' },
	            'Close'
	        )
	    );
	};
	
	Menu.propTypes = {
	    onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(415);
	
	var _Header = __webpack_require__(213);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Menu = __webpack_require__(214);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Contact = __webpack_require__(211);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Footer = __webpack_require__(212);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	    _inherits(Template, _React$Component);
	
	    function Template(props) {
	        _classCallCheck(this, Template);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            isMenuVisible: false,
	            loading: 'is-loading'
	        };
	        _this.handleToggleMenu = _this.handleToggleMenu.bind(_this);
	        return _this;
	    }
	
	    Template.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.timeoutId = setTimeout(function () {
	            _this2.setState({ loading: '' });
	        }, 100);
	    };
	
	    Template.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.timeoutId) {
	            clearTimeout(this.timeoutId);
	        }
	    };
	
	    Template.prototype.handleToggleMenu = function handleToggleMenu() {
	        this.setState({
	            isMenuVisible: !this.state.isMenuVisible
	        });
	    };
	
	    Template.prototype.render = function render() {
	        var children = this.props.children;
	
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'body ' + this.state.loading + ' ' + (this.state.isMenuVisible ? 'is-menu-visible' : '') },
	            _react2.default.createElement(
	                'div',
	                { id: 'wrapper' },
	                _react2.default.createElement(_Header2.default, { onToggleMenu: this.handleToggleMenu }),
	                children(),
	                _react2.default.createElement(_Contact2.default, null),
	                _react2.default.createElement(_Footer2.default, null)
	            ),
	            _react2.default.createElement(_Menu2.default, { onToggleMenu: this.handleToggleMenu })
	        );
	    };
	
	    return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	    children: _react2.default.PropTypes.func
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-4090bddf54d6c0ec62b7.js